<template>
    <div class="ns-tier-group-card tx-font-primary" :class="[ 'tg-layout-' + layout ]" :id="baseId">
        <!-- Layout: Custom -->
        <template v-if="isCustomTier">
            <v-layout class="tg-tiering-content" :id="`${baseId}-custom-tier`">
                <v-flex v-for="(tier, index) in tiers" :key="index" xs12 md10 offset-md1 lg10 offset-lg1 :id="`${baseId}-custom-tier-tier-${index}`">
                    <v-card
                        class="tier-summary"
                        :class="['tier-' + (index + 1)]"
                        :id="`${baseId}-custom-tier-tier-${index}-card`"
                    >
                        <v-card-title class="tier-title justify-center ma-0 pa-0" :id="`${baseId}-custom-tier-tier-${index}-card-title`">
                            <h1 class="text" :id="`${baseId}-custom-tier-tier-${index}-tier-id`">{{ $nsLanguage.getTranslation('tieringDashboardPage.' + tier.tierId) }}</h1>
                        </v-card-title>
                        <v-card-text class="custom-message tx-gray-dark justify-center mt-8 pa-0" :id="`${baseId}-custom-tier-tier-${index}-card-text`">
                            <div
                                class="text-center tx-em-bold-800"
                                v-html="$nsLanguage.getTranslation('tieringDashboardPage.' + tier.content)"
                                :id="`${baseId}-custom-tier-tier-${index}-tier-content`"
                            >
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>
        <section v-else class="tg-content" :id="`${baseId}-non-custom-tier`">
            <div v-if="configuration.context" class="tg-head" :id="`${baseId}-non-custom-tier-dashboard-title-container`">
                <h1 class="tg-head-text tx-font-primary" :id="`${baseId}-non-custom-tier-dashboard-title-text`">
                    {{ $nsLanguage.getTranslation(configuration.context + '.dashboardTitle') }}
                </h1>
            </div>
            <div v-if="isMobile" class="tg-tier-content" :id="`${baseId}-non-custom-tier-mobile-container`">
                <!-- Mobile -->
                <v-tabs
                    active-class="tab-visible"
                    class="tg-tier-menu"
                    :class="['tg-tier-menu-color-' + getTierColor(visibleTierIndex, configuration.defaultTierColor)]"
                    center-active
                    centered
                    height="80px"
                    show-arrows
                    slider-size="2px"
                    v-model="visibleTierIndex"
                    :id="`${baseId}-non-custom-tier-mobile-tabs`"
                >
                    <v-tabs-slider color="#000000" :id="`${baseId}-non-custom-tier-mobile-tabs-slider`"></v-tabs-slider>
                    <v-tab
                        v-for="(tier, index) in tiers"
                        :key="index"
                        class="tier-tab"
                        :class="[isTierActive(index) ? 'tab-active' : '', 'tg-tier-menu-color-' + getTierColor(index, configuration.defaultTierColor)]"
                        @click="switchTab('loyaltyTier' + (index + 1))"
                        :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}`"
                    >
                        <div class="tier-tab-container" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-tab-container`">
                            <div v-if="!isTierLocked(index) && !isTierActive(index)" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-inactive-container`">
                                <img class="tab-image" :src="getTierLockImage(index, 'inactive')" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-inactive-image`" />
                            </div>
                            <div v-if="!isTierLocked(index) && isTierActive(index)" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-active-container`">
                                <img class="tab-image" :src="getTierLockImage(index, 'active')" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-active-image`" />
                            </div>
                            <div v-if="isTierLocked(index)" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-locked-container`">
                                <img class="tab-image" :src="getTierLockImage(index, 'closed')" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-locked-image`" />
                            </div>
                            <div class="tab-text tx-font-primary" :id="`${baseId}-non-custom-tier-mobile-tabs-tier-${index}-tier-id`">
                                {{ $nsLanguage.getTranslation(configuration.context + '.' + tier.tierId) }}
                            </div>
                        </div>
                    </v-tab>
                </v-tabs>
                <div class="tg-tier-card-container" :id="`${baseId}-non-custom-tier-mobile-tier-card-container`">
                    <div
                        v-for="(tier, index) in tiers"
                        :key="index"
                        class="tg-tier-card"
                        :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}`"
                    >
                        <template v-if="isTierVisible(index)">
                            <ns-tier-card
                                :layout="layout"
                                :shadow="isTierActive(index)"
                                :togglable="togglable"
                                :type="tier.tierType"
                                :color="getTierColor(index, configuration.defaultTierColor, tier.tierType == 'vip')"
                                :icon="getTierIcon(tier, configuration.defaultTierIcon)"
                                :configuration="configuration"
                                :content="tier"
                                :parent-id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}`"
                            >
                                <!-- VIP -->
                                <template v-if="tier.tierType == 'vip'" #additional>
                                    <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional`">
                                        <h4 class="text-uppercase" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-tier-title`">
                                            {{ $nsLanguage.getTranslation(configuration.context + '.unlockTierTitle') }}
                                        </h4>
                                        <div class="tgtc-link" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-telephone-link-container`">
                                            <span
                                                class="text-capitalize"
                                                :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-telephone-link-text`"
                                            >
                                                {{ $nsLanguage.getTranslation(configuration.context + '.call') }}
                                                <a
                                                    :href="getTelephoneLink($nsLanguage.getTranslation(configuration.context + '.vipTelephone'))"
                                                    :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-telephone-link-link`"
                                                >
                                                    {{ $nsLanguage.getTranslation(configuration.context + '.vipTelephone') }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <!-- Locked/VIP (+progress) -->
                                <template v-else-if="canUnlockTier(index) && tier.showUnlockRule && tier.tierType == 'vip'" #additional>
                                    <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable`">
                                        <h4 class="text-uppercase" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-tier-title`">
                                            {{ $nsLanguage.getTranslation(configuration.context + '.unlockTierTitle') }}
                                        </h4>
                                        <p class="ma-0 my-2" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-tier-text-short`">
                                            {{ $nsLanguage.getTranslation(configuration.context + '.tier3UnlockTierTextShort', tier) }}
                                        </p>
                                        <h4
                                            class="tgtc-progress-text tx-font-primary text-center tx-gray-dark mt-2"
                                            :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-points-acquired`"
                                        >
                                            {{ currency(tier.pointsAcquired) }} / {{ currency(getTierThreshold(index)) }}
                                        </h4>
                                        <v-progress-linear
                                            class="progress-bar"
                                            color="rgb(2, 178, 223)"
                                            background-color="rgba(229, 229, 229)"
                                            height="6"
                                            :value="tier.pointsAcquired!=0?(tier.pointsAcquired/getTierThreshold(index)*100):0"
                                            :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-progress-linear`"
                                        />
                                        <p class="ma-0 mt-5" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-call-us-invite`">
                                            {{ $nsLanguage.getTranslation(configuration.context + '.callUsInvite') }}
                                        </p>
                                        <div
                                            class="tgtc-link"
                                            :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-vip-telephone-container`"
                                        >
                                            <span
                                                class="text-capitalize"
                                                :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-vip-telephone-text`"
                                            >
                                                {{ $nsLanguage.getTranslation(configuration.context + '.call') }}
                                                <a
                                                    :href="getTelephoneLink($nsLanguage.getTranslation(configuration.context + '.vipTelephone'))"
                                                    :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-vip-additional-unlockable-vip-telephone-link`"
                                                >
                                                    {{ $nsLanguage.getTranslation(configuration.context + '.vipTelephone') }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <!-- Locked/AE -->
                                <template v-else-if="isTierLocked(index) && tier.unlockable && tier.showUnlockRule && tier.tierType != 'vip'" #additional>
                                    <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock`">
                                        <h4 class="text-uppercase" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-tier-title`">
                                          {{ $nsLanguage.getTranslation(configuration.context + '.unlockTierTitle') }}
                                        </h4>
                                        <template v-if="tier.unlockText">
                                            <p
                                              class="text-center tx-gray-light ma-0"
                                              v-if="tier.unlockLink"
                                              :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-link-container`"
                                            >
                                                <a
                                                  class="summary-link"
                                                  :href="mapLink(tier.unlockLink)"
                                                  v-html="$nsLanguage.getTranslation(configuration.context + '.' + tier.unlockText, tier)"
                                                  @click="publishEvent($event, tier)"
                                                  :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-link`"
                                                >
                                                </a>
                                            </p>
                                            <p
                                              class="text-center tx-gray-light tx-em-bold-800 ma-0"
                                              v-else
                                              v-html="$nsLanguage.getTranslation(configuration.context + '.' + tier.unlockText, tier)"
                                              :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-text`"
                                            >
                                            </p>
                                        </template>
                                        <template v-if="tier.showProgress">
                                            <h4
                                              class="tgtc-progress-text tx-font-primary text-center tx-gray-dark mt-2"
                                              :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-points-acquired`"
                                            >
                                              {{ currency(tier.pointsAcquired) }} / {{ currency(getTierThreshold(index)) }}
                                            </h4>
                                            <v-progress-linear
                                                class="progress-bar"
                                                color="rgb(2, 178, 223)"
                                                background-color="rgba(229, 229, 229)"
                                                height="6"
                                                :value="tier.pointsAcquired!=0?(tier.pointsAcquired/getTierThreshold(index)*100):0"
                                                :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-progress-linear`"
                                            />
                                        </template>
                                        <div
                                          class="tc-button-container"
                                          v-if="tier.unlockButtonText"
                                          :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-button-link-container`"
                                        >
                                            <a
                                              class="tx-dec-none" :href="mapLink(tier.unlockButtonLink)"
                                              :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-button-link-link`"
                                            >
                                                <button
                                                  class="primary-solid fluid"
                                                  :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-non-vip-unlock-button-link-button`"
                                                >
                                                  {{ $nsLanguage.getTranslation(configuration.context + '.' + tier.unlockButtonText) }}
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </template>
                                <!-- Unlocked -->
                                <template v-else-if="!isTierLocked(index)" #additional >
                                    <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-unlocked`">
                                        <h4 class="ma-0 text-uppercase" :id="`${baseId}-non-custom-tier-mobile-tier-card-container-tier-${index}-unlocked-title`">
                                          {{ $nsLanguage.getTranslation(configuration.context + '.unlocked') }}
                                        </h4>
                                    </div>
                                </template>
                            </ns-tier-card>
                        </template>
                    </div>
                </div>
            </div>
            <div v-else class="tg-tier-content">
                <!-- Tablet/Desktop -->
                <div
                    v-for="(tier, index) in tiers"
                    :key="index"
                    class="tg-tier-card"
                    :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}`"
                >
                    <ns-tier-card
                        :layout="layout"
                        :shadow="isTierActive(index)"
                        :togglable="togglable"
                        :type="tier.tierType"
                        :color="getTierColor(index, configuration.defaultTierColor, tier.tierType == 'vip')"
                        :icon="getTierIcon(tier, configuration.defaultTierIcon)"
                        :configuration="configuration"
                        :content="tier"
                        :parent-id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}`"
                    >
                        <!-- Locked/VIP -->
                        <template v-if="tier.tierType == 'vip'" #additional>
                            <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip`">
                                <h4 class="text-uppercase" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-tier-title`">
                                    {{ $nsLanguage.getTranslation(configuration.context + '.unlockTierTitle') }}
                                </h4>
                                <div class="tgtc-link" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-telephone-link-container`">
                                    <span class="text-capitalize" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-telephone-link-text`">
                                        {{ $nsLanguage.getTranslation(configuration.context + '.call') }}
                                        <a
                                            :href="getTelephoneLink($nsLanguage.getTranslation(configuration.context + '.vipTelephone'))"
                                            :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-telephone-link-link`"
                                        >
                                            {{ $nsLanguage.getTranslation(configuration.context + '.vipTelephone') }}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <!-- Locked/VIP (+progress) -->
                        <template v-else-if="isTierLocked(index) && canUnlockTier(index) && tier.unlockable && tier.showUnlockRule && tier.tierType == 'vip'" #additional>
                            <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress`">
                                <h4 class="text-uppercase" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-tier-title`">
                                    {{ $nsLanguage.getTranslation(configuration.context + '.unlockTierTitle') }}
                                </h4>
                                <p class="ma-0 my-2" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-unlock-tier-text-short`">
                                    {{ $nsLanguage.getTranslation(configuration.context + '.tier3UnlockTierTextShort', tier) }}
                                </p>
                                <h4
                                    class="tgtc-progress-text tx-font-primary text-center tx-gray-dark"
                                    :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-points-acquired`"
                                >
                                    {{ currency(tier.pointsAcquired) }} / {{ currency(getTierThreshold(index)) }}
                                </h4>
                                <v-progress-linear
                                    class="progress-bar"
                                    color="rgb(2, 178, 223)"
                                    background-color="rgba(229, 229, 229)"
                                    height="6"
                                    :value="tier.pointsAcquired!=0?(tier.pointsAcquired/getTierThreshold(index)*100):0"
                                    :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-progress-linear`"
                                />
                                <p class="ma-0 mt-5" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-call-us-invite`">
                                    {{ $nsLanguage.getTranslation(configuration.context + '.callUsInvite') }}
                                </p>
                                <div class="tgtc-link" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-telephone-link-container`">
                                    <span class="text-capitalize" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-telephone-text`">
                                        {{ $nsLanguage.getTranslation(configuration.context + '.call') }}
                                        <a
                                          :href="getTelephoneLink($nsLanguage.getTranslation(configuration.context + '.vipTelephone'))"
                                          :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-vip-progress-telephone-link-link`"
                                        >
                                            {{ $nsLanguage.getTranslation(configuration.context + '.vipTelephone') }}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <!-- Locked/AE -->
                        <template v-else-if="isTierLocked(index) && tier.unlockable && tier.showUnlockRule && tier.tierType != 'vip'" #additional>
                            <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip`">
                                <h4 class="text-uppercase" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-tier-title`">
                                  {{ $nsLanguage.getTranslation(configuration.context + '.unlockTierTitle') }}
                                </h4>
                                <template v-if="tier.unlockText">
                                    <p
                                      class="text-center tx-gray-light ma-0"
                                      v-if="tier.unlockLink"
                                      :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-link-container`"
                                    >
                                        <a
                                          class="summary-link"
                                          :href="mapLink(tier.unlockLink)"
                                          v-html="$nsLanguage.getTranslation(configuration.context + '.' + tier.unlockText, tier)"
                                          @click="publishEvent($event, tier)"
                                          :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-link-link`"
                                        >
                                        </a>
                                    </p>
                                    <p
                                      class="text-center tx-gray-light tx-em-bold-800 ma-0"
                                      v-else
                                      v-html="$nsLanguage.getTranslation(configuration.context + '.' + tier.unlockText, tier)"
                                      :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-text`"
                                    >
                                    </p>
                                </template>
                                    <template v-if="tier.showProgress">
                                        <h4
                                          class="tgtc-progress-text tx-font-primary text-center tx-gray-dark mt-2"
                                          :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-progress`"
                                        >
                                          {{ currency(tier.pointsAcquired) }} / {{ currency(getTierThreshold(index)) }}
                                        </h4>
                                        <v-progress-linear
                                            class="progress-bar"
                                            color="rgb(2, 178, 223)"
                                            background-color="rgba(229, 229, 229)"
                                            height="6"
                                            :value="tier.pointsAcquired!=0?(tier.pointsAcquired/getTierThreshold(index)*100):0"
                                            :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-progress-linear`"
                                        />
                                    </template>
                                <div
                                  class="tc-button-container"
                                  v-if="tier.unlockButtonText"
                                  :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-button-container`"
                                >
                                    <a
                                      class="tx-dec-none"
                                      :href="mapLink(tier.unlockButtonLink)"
                                      :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-button-link`"
                                    >
                                        <button class="primary-solid fluid" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-non-vip-unlock-button-button`">
                                          {{ $nsLanguage.getTranslation(configuration.context + '.' + tier.unlockButtonText) }}
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </template>
                        <!-- Unlocked -->
                        <template v-else-if="!isTierLocked(index)" #additional>
                            <div class="tgtc-additional" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-tier-unlocked-container`">
                                <h4 class="ma-0 text-uppercase" :id="`${baseId}-non-custom-tier-non-mobile-tier-card-tier-${index}-tier-unlocked-text`">
                                  {{ $nsLanguage.getTranslation(configuration.context + '.unlocked') }}
                                </h4>
                            </div>
                        </template>
                    </ns-tier-card>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import { formatPoints } from '../../../services/points'
import { events } from '@nuskin/ns-util'

import NsTierCard from '@/components/Tiering/TierCard.vue'

const LOCK_ICONS = {
    active: {
        blue: require('@/assets/icons/Icon_LockOpen_ActiveBlue.svg'),
        gray: require('@/assets/icons/Icon_LockOpen_ActiveGray.svg'),
        green: require('@/assets/icons/Icon_LockOpen_ActiveGreen.svg'),
        red: require('@/assets/icons/Icon_LockOpen_ActiveRed.svg')
    },
    inactive: {
        blue: require('@/assets/icons/Icon_LockOpen_InactiveGray.svg'),
        gray: require('@/assets/icons/Icon_LockOpen_InactiveGray.svg'),
        green: require('@/assets/icons/Icon_LockOpen_InactiveGray.svg'),
        red: require('@/assets/icons/Icon_LockOpen_InactiveGray.svg')
    },
    closed: {
        blue: require('@/assets/icons/Icon_LockClosed_Gray.svg'),
        gray: require('@/assets/icons/Icon_LockClosed_Gray.svg'),
        green: require('@/assets/icons/Icon_LockClosed_Gray.svg'),
        red: require('@/assets/icons/Icon_LockClosed_Gray.svg')
    }
}

export default {
    name: 'ns-tier-group-card',
    components: {
        'ns-tier-card': NsTierCard
    },
    props: {
        color: {
            type: String,
            default: ''
        },
        layout: {
            type: String,
            default: 'mobile',
            validator (value) {
                return ['mobile', 'tablet', 'desktop'].indexOf(value) >= 0
            }
        },
        links: {
            type: Object,
            default: function () {
                return {}
            }
        },
        parentId: {
            type: String,
            required: false,
            default: ''
        },
        togglable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            activeTierIndex: -1,
            visibleTierIndex: -1,
            configuration: {},
            tiers: []
        }
    },
    computed: {
        baseId: function () {
            const defaultBase = 'dashoard-tier-group-card'
            if (this.parentId) {
                return `${this.parentId}-${defaultBase}`
            } else {
                return defaultBase
            }
        },
        isCustomTier () {
            return this.tiers.length > 0 && this.tiers[0].template === 'custom'
        },
        isMobile () {
            return this.layout === 'mobile'
        },
        isTablet () {
            return this.layout === 'tablet'
        }
    },
    methods: {
        currency (value) {
            return formatPoints(value)
        },
        canUnlockTier (index) {
            const tier = this.tiers[index]

            return !!(tier && tier.unlockable)
        },
        getTelephoneLink (text) {
            return 'tel:' + text.replace(/[^\d]+/g, '')
        },
        getTierColor (index, defaultColor, forceColor) {
            let color = 'gray'

            const tier = this.tiers[index]
            if (tier && (tier.forceColor || this.isTierActive(index)) && (forceColor || !this.isTierLocked(index))) {
                color = tier.color || defaultColor
            }

            return color
        },
        getTierIcon (tier, defaultIcon) {
            return tier.icon || defaultIcon
        },
        getTierLockImage (index, context) {
            let image = LOCK_ICONS.closed.gray

            const tier = this.tiers[index]
            if (tier) {
                const color = this.getTierColor(index, this.configuration.defaultTierColor)

                image = LOCK_ICONS[context][color]
            }

            return image
        },
        getTierThreshold (index) {
            return this.tiers[index].tierThreshold
        },
        isTierActive (index) {
            return index === this.activeTierIndex
        },
        isTierLocked (index) {
            return index > this.activeTierIndex
        },
        isTierVisible (index) {
            return this.isMobile || this.isTablet ? (index === this.visibleTierIndex) : true
        },
        mapLink (link) {
            return this.links[link]
        },
        switchTab (eventName) {
            events.tag(eventName, { context: 'dashboard' })
        },
        setActiveTier (activeTierId) {
            this.activeTierIndex = this.tiers.findIndex((tier) => {
                return activeTierId === tier.tierId
            })

            if (this.visibleTierIndex < 0) {
                this.visibleTierIndex = this.activeTierIndex
            }
        },
        setConfiguration (configuration) {
            this.configuration = configuration
        },
        setTiers (tiers) {
            this.tiers = tiers

            const tier = this.tiers[this.activeTierIndex]
            if (tier) {
                this.setActiveTier(tier.tierId)
            } else {
                this.activeTierIndex = -1
                this.visibleTierIndex = -1
            }
        }
    }
}

</script>

<style lang="scss" scoped>

@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/buttons";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

$color-blue: #02B2DF;
$color-gray-38: map.get(colors.$baseColors, blackhole);
$color-green: #40BDA5;
$color-red: #BE0077;

a {
    color: $color-blue !important;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }

    button {
        text-decoration: none;
    }
}

.tx-em-bold-800 {
    ::v-deep {
        b, em, i {
            font-family: inherit;
            font-style: normal;
            font-weight: 800;
        }
    }
}

.tx-em-italic {
    ::v-deep {
        b, em, i {
            font-style: italic;
        }
    }
}

.tx-gray-dark {
    color: $color-gray-38 !important;
}

.tg-tiering-content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    padding: 0;
    background-color: transparent;
    border-radius: 0;
    font-size: 14px;
}

.tier-title {
    margin: 0 0 15px;
    padding: 0;

    .text {
        font-size: 20px !important;
        font-weight: 600 !important;
        text-transform: uppercase;
    }
}

.tier-summary {
    display: block;
    overflow: visible;
    position: relative;
    text-align: initial;
    width: 100%;
    margin: 0;
    padding: 0;
    background-color: transparent;
    border-radius: 0;
    box-shadow: none;
    font-size: 14px;
}

.custom-message {
    ::v-deep {
        em {
            font-style: normal;
            font-weight: 800;
        }
    }
}

.ns-tier-group-card {
    $tg-padding: 30px;

    display: inline-block;
    position: relative;
    width: 100%;
    text-align: left;
    font-size: 16px;

    & + .ns-tier-group-card {
        margin-top: -$tg-padding + 10px;
    }

    // &.tg-layout-mobile {
    // }

    &.tg-layout-tablet,
    &.tg-layout-desktop {
        .tg-tier-content {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 30px;
        }

        .tg-tier-card + .tg-tier-card {
            margin-left: 18px;
        }
    }

    &.tg-layout-mobile {
        .tg-tier-card {
            width: 100%;
        }
    }
}

.tg-content {
    display: block;
    z-index: 100;
    position: relative;
    width: 100%;
    padding: 0;
    color: rgba(0, 0, 0, 0.85);
}

.tg-head {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0;
}

.tg-head-text {
    color: rgba(0, 0, 0, 0.85);
    font-size: 30px;
    font-weight: normal;
    line-height: 1em;
    text-align: center;
    text-transform: none;
}

.tg-tier-content {
    display: block;
    flex-direction: row;
    justify-content: center;
    align-content: flex-start;
    align-items: flex-start;
    margin-top: 25px;
}

.tg-tier-card-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
}

.tgtc-additional {
    ::v-deep {
        .v-progress-linear__determinate {
            position: relative;
        }
    }

    button {
        font-size: 16px;
        line-height: 1.0625em;
    }

    h1, h2, h3, h4, h5, h6 {
        margin: 0 0 10px 0;
        color: #272525;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.2857em;
        text-align: center;
    }

    p {
        margin: 5px 0 0 0;
        color: #7B7C81;
        font-size: 12px;
        font-weight: normal;
        text-align: center;
        line-height: 1.44em;
    }

    .tgtc-link {
        padding: 8px 15px;
        background-color: #FFFFFF;
        color: #63666A;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.5em;
        text-align: center;
    }

    .tgtc-progress-text {
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: normal;
        letter-spacing: 0px;
        line-height: 1.2857em;
        text-align: center;
    }

    .tc-button-container {
        margin-top: 15px;
    }
}

.tg-tier-menu {
    ::v-deep {
        .v-tabs-slider-wrapper {
            height: 3px;

            .v-tabs-slider {
                $transition-duration: 300ms;
                $transition-function: cubic-bezier(0.25, 0.80, 0.50, 1);

                transition: background-color $transition-duration $transition-function, border-color $transition-duration $transition-function;
            }
        }
    }

    .v-tabs-bar {
        background-color: transparent;
    }

    .tab-image {
        width: 16px;
        height: 16px;
        margin-bottom: 10px;
    }

    .tier-tab-container {
        display: block;
    }

    .tab-text,
    .tab-active .tab-text {
        color: rgba(0, 0, 0, 0.50);
    }

    .tab-text {
        font-size: 20px;
        font-weight: 600;
    }

    &.tg-tier-menu-color-blue {
        ::v-deep {
            .v-tabs-slider {
                background-color: $color-blue !important;
                border-color: $color-blue !important;
            }
        }
    }

    & .tg-tier-menu-color-blue {
        .tab-text {
            color: $color-blue;
        }
    }

    &.tg-tier-menu-color-gray {
        $color-gray: rgba(0, 0, 0, 0.50);

        ::v-deep {
            .v-tabs-slider {
                background-color: $color-gray !important;
                border-color: $color-gray !important;
            }
        }
    }

    &.tg-tier-menu-color-green {
        ::v-deep {
            .v-tabs-slider {
                background-color: $color-green !important;
                border-color: $color-green !important;
            }
        }
    }

    & .tg-tier-menu-color-green {
        .tab-text {
            color: $color-green;
        }
    }

    &.tg-tier-menu-color-red {
        ::v-deep {
            .v-tabs-slider {
                background-color: $color-red !important;
                border-color: $color-red !important;
            }
        }
    }

    & .tg-tier-menu-color-red {
        .tab-text {
            color: $color-red;
        }
    }
}

</style>
